import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Services.css';
import samplelogo from '../images/seal1.png';
import w1 from '../images/w1.jpg';
import w2 from '../images/w2.png';
import w3 from '../images/w3.png';
import w4 from '../images/w4.png';
import w5 from '../images/w5.jpg';
import w6 from '../images/w6.png';

const Services1 = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="finance-info-section">
      <div className="finance-header">
        <h2>Water Based <span className="highlight">Adhesive</span></h2>
      </div>
      <div className="finance-header1">
        <h2 style={{ color: 'white' }}>
          <img
            src={samplelogo} 
            alt="SEALACTIVE Logo"
            className="sealactive-logo"
          />{' '}
          Produce Water Based Adhesives , and also known as waterborne adhesives, are a type of adhesive that is dispersed or dissolved in water as the primary carrier or solvent. These adhesives are formulated using a combination of polymers, additives, and water.In response to the trend of green chemistry in place of solvent-based products, we have developed functional water-based emulsion pressure-sensitive adhesive (PSA) products that come with several different features such as having less odor and low volatile organic compounds (V.O.C.).
        </h2>
      </div>

      <div className="finance-container">
        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
            src={w1}
            alt="Personal Finance"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={w2}
            alt="Investment Planning"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-right" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
            src={w3} 
            alt="Market Analysis"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
           
            </p> */}
          </div>
        </div>
        <div className="finance-card" data-aos="fade-left" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={w4} 
            alt="Personal Finance"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-left" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={w5} 
            alt="Investment Planning"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>

        <div className="finance-card" data-aos="fade-left" data-aos-duration="1000">
          <div className="card-overlay"></div>
          <img
          src={w6} 
            alt="Market Analysis"
          />
          <div className="card-content">
            {/* <h3></h3>
            <p>
            
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services1;